import {InstancedMesh,Matrix4,SphereGeometry} from 'three';

const transparentGroups=new WeakMap();
const farToNear=(a,b)=>a.depth-b.depth;
const beadGeometry=(kind,mobile)=>{
  const [width,height]=kind==='gelbeads'?(mobile?[16,12]:[20,16]):(mobile?[12,8]:[20,14]);
  return new SphereGeometry(1,width,height);
};

export function resizeBeadGroups(groups,kind,mobile){
  for(const group of groups){
    group.geometry.dispose();
    group.geometry=beadGeometry(kind,mobile);
    group.computeBoundingSphere();group.computeBoundingBox();
  }
}

export function createBeadGroups(particles,kind,mobile=false){
  const gel=kind==='gelbeads',batches=new Map(),groups=[];
  for(const item of particles){
    const key=gel?'gel':item.mesh.material.name;
    if(!batches.has(key))batches.set(key,[]);
    batches.get(key).push(item);
  }
  for(const items of batches.values()){
    const material=items[0].mesh.material.clone();
    if(gel)material.color.setHex(0xffffff);
    const instances=new InstancedMesh(beadGeometry(kind,mobile),material,items.length);
    instances.frustumCulled=false;instances.castShadow=!gel;instances.receiveShadow=!gel;
    items.forEach((item,index)=>{
      item.mesh.removeFromParent();item.instances=instances;item.instanceIndex=index;
      if(gel)instances.setColorAt(index,item.mesh.material.color);
    });
    if(gel)transparentGroups.set(instances,{
      modelView:new Matrix4(),
      entries:items.map(item=>({item,matrix:new Matrix4(),color:item.mesh.material.color.clone(),depth:0})),
    });
    groups.push(instances);
  }
  return groups;
}

// Call after updating the particle matrices, including frames that only orbit.
// Sorting slots also updates particle identity so the next physics frame writes
// its new position into the correct slot. No per-frame matrices are allocated.
export function sortGelBeads(particles,toy,camera){
  const instances=particles[0]?.instances,state=transparentGroups.get(instances);
  if(!state)return;
  camera.updateMatrixWorld();toy.updateMatrixWorld(true);
  const view=state.modelView.multiplyMatrices(camera.matrixWorldInverse,instances.matrixWorld).elements;
  for(const entry of state.entries){
    instances.getMatrixAt(entry.item.instanceIndex,entry.matrix);
    const e=entry.matrix.elements;
    entry.depth=view[2]*e[12]+view[6]*e[13]+view[10]*e[14]+view[14];
  }
  state.entries.sort(farToNear);
  state.entries.forEach((entry,index)=>{
    instances.setMatrixAt(index,entry.matrix);instances.setColorAt(index,entry.color);entry.item.instanceIndex=index;
  });
  instances.instanceMatrix.needsUpdate=true;instances.instanceColor.needsUpdate=true;
}
